import { createLoadableComponent, createModuleLoader } from '@mews/framework';
import { showDates } from '../../actions/navigation';
import { createViewLoadingError } from '../../components/common/createViewLoadingError';
import { moduleId } from './constants';

export const loader = createModuleLoader({
    name: moduleId,
    load: async () => import(/* webpackChunkName: "enterprises" */ './module'),
    dependencies: [],
});

export const Enterprises = createLoadableComponent({
    loader,
    component: 'HotelsView',
    ...createViewLoadingError({
        dismissAction: showDates,
    }),
});
